import actionTypes from '../actionTypes';

export function successGameCategories(data) {
  return {
    type: actionTypes.GAME_CATEGORIES_SUCCESS,
    value: [...data]
  };
}

export function setGameCategory( category ) {
  return {
    type: actionTypes.SET_GAME_CATEGORY,
    selected: category
  };
}

export function setGameCategories(data) {
  return {
    type: actionTypes.SET_GAME_CATEGORIES,
    value: data
  };
}
